require("dotenv").config();

import debug from "debug";
import os from "os";

const { env = {} } = process || {};

/**
 * isDev
 */
export const isDev = env.NODE_ENV !== "production";

/**
 * APP_NAME
 */
export const APP_NAME = env.APP_NAME || "APP_NAME";

/**
 * HOSTNAME
 */
export const HOSTNAME = os.hostname();

/**
 * PORT
 */
export const PORT = env.PORT || 3000;

/**
 * TRADE_ENV
 */
export const TRADE_ENV = env.TRADE_ENV || "paper";

/**
 * RethinkDB config
 */
export const RETHINKDB_DB =
  env.RETHINKDB_DB || (TRADE_ENV === "paper" ? "paper" : "stoqey");

/**
 * RETHINKDB_HOST
 */
export const RETHINKDB_HOST: string = env.RETHINKDB_HOST || "localhost";

/**
 * RETHINKDB_PORT
 */
export const RETHINKDB_PORT: number = +(env.RETHINKDB_PORT || "");

/**
 * POSITION_SERVER_SERVICE_HOST
 */
export const POSITION_SERVER_SERVICE_HOST = `http://${
  env.POSITION_SERVER_SERVICE_HOST || "localhost"
}`;

/**
 * POSITION_SERVER_SERVICE_PORT
 */
export const POSITION_SERVER_SERVICE_PORT =
  env.POSITION_SERVER_SERVICE_PORT || 3002;

/**
 * EXODUS_SERVICE_HOST
 */
export const EXODUS_SERVICE_HOST = `http://${
  env.EXODUS_SERVICE_HOST || "localhost"
}`;

/**
 * EXODUS_SERVICE_PORT
 */
export const EXODUS_SERVICE_PORT = env.EXODUS_SERVICE_PORT || 3009;

/**
 * FINNHUB_KEY
 */
export const FINNHUB_KEY = env.FINNHUB_KEY || "";

/**
 * IB_PORT
 */
export const IB_PORT: number = +(isDev ? env.IB_PORT || 7496 : 4003);

/**
 * IB_HOST
 */
export const IB_HOST: string = isDev
  ? env.IB_HOST || "127.0.0.1"
  : env.IBKR_SERVICE_HOST;

/**
 * -----------------------------------------   COMMON modules, logs, events, e.t.c -------------------------------
 */

const loggingPrefix = APP_NAME || "server";

/**
 * Use to log in general case
 */
export const log = debug(`${loggingPrefix}:info`);

/**
 * Use for verbose log
 */
export const verbose = debug(`${loggingPrefix}:verbose`);

// APP events
export * from "./AppEvents";
